export default "__VITE_ASSET__DlNITCZL__"